import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuoteList } from '../hooks/useQuoteList';

const QuoteListWidget: React.FC = () => {
  const navigate = useNavigate();
  const { list, listCount, totalItems, isOpen, setIsOpen, removeFromList, updateQuantity } = useQuoteList();

  const handleEmailClick = () => {
    navigate('/email-quote');
  };

  return (
    <>
      {/* Quote Icon */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-24 right-6 z-50 bg-cyan-500 hover:bg-cyan-600 text-white p-3 rounded-full shadow-lg transition-colors cursor-pointer"
      >
        <i className="ri-file-list-3-line text-xl"></i>
        {totalItems > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center">
            {totalItems}
          </span>
        )}
      </button>

      {/* Quote Panel */}
      {isOpen && (
        <div className="fixed top-24 right-6 z-40 bg-white border border-gray-200 rounded-lg shadow-xl w-80 max-h-96 overflow-hidden">
          <div className="bg-cyan-500 text-white p-4 flex items-center justify-between">
            <h3 className="font-semibold">My List ({listCount} items)</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-200 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
          
          <div className="p-4">
            {list.length === 0 ? (
              <div className="text-center py-8">
                <i className="ri-file-list-3-line text-4xl text-gray-300 mb-2"></i>
                <p className="text-gray-500">Your list is empty</p>
                <p className="text-sm text-gray-400 mt-1">Add mattresses to your selection</p>
              </div>
            ) : (
              <>
                <div className="space-y-3 max-h-48 overflow-y-auto mb-4">
                  {list.map((item) => (
                    <div key={item.id} className="p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-start justify-between mb-2">
                        <div className="flex-1">
                          <p className="font-medium text-sm">{item.brand} • {item.collection}</p>
                          <p className="text-sm text-gray-600">{item.name}</p>
                          <p className="text-xs text-gray-500">{item.size}</p>
                        </div>
                        <button
                          onClick={() => removeFromList(item.id)}
                          className="text-red-500 hover:text-red-700 ml-2 cursor-pointer"
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                      
                      {/* Quantity Controls */}
                      <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600">Quantity:</span>
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                            className="w-6 h-6 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-gray-600 cursor-pointer"
                          >
                            <i className="ri-subtract-line text-xs"></i>
                          </button>
                          <span className="w-8 text-center text-sm font-medium">{item.quantity}</span>
                          <button
                            onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                            className="w-6 h-6 bg-gray-200 hover:bg-gray-300 rounded-full flex items-center justify-center text-gray-600 cursor-pointer"
                          >
                            <i className="ri-add-line text-xs"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                <button
                  onClick={handleEmailClick}
                  className="w-full bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white py-3 px-4 rounded-lg font-medium transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
                >
                  <i className="ri-mail-send-line mr-2"></i>
                  Email My Detailed Selections
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );

  function handleQuantityChange(mattressId: string, newQuantity: number) {
    updateQuantity(mattressId, newQuantity);
  }
};

export default QuoteListWidget;
